<template>
  <Widget edge disable class="bg-secondary border-secondary text-white borde0" name="prayerTimes" title="Prayer Times"
    img="data:image/svg+xml;utf8;base64,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"
  >
    <button slot="toolbar-button" class="btn btn-outline-light" @click="previous"><i class="fas fa-arrow-left"></i></button>
    <button slot="toolbar-button" class="btn btn-light" @click="today">Today</button>
    <button slot="toolbar-button" class="btn btn-outline-light" @click="next"><i class="fas fa-arrow-right"></i></button>
    <div v-if="$store.state.location" class="table-responsive">
    <table class="table table-striped bg-light text-dark table- mb-0">
      <thead class="thead-lig">
        <tr>
          <th>&nbsp;</th>
          <th v-for="(time, date) in times" :key="date" :class="{'table-active' : (date == todayDate)}">{{ date == todayDate ? 'Today' : date }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(title, name) in prayers" :key="name">
          <th>{{ title }}</th>
          <td v-for="(time, date) in times" :key="date" :class="{'table-active ' : (date == todayDate)}">{{ time[name] }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </Widget>
</template>
<script>
import moment from 'moment';
import Widget from "@/Widget";

export default {
  components: { Widget },
  computed: {
    prayers() {
      return this.$store.state.prayerTimeNames;
    },

    limit() {
      let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if(w && w < 500) {
        return 2;
      }

      return 4;
    },

    times() {
      return this.$store.state.prayerService.getTimes(
        this.cursor,
        [this.$store.state.location.lat, this.$store.state.location.lng],
        this.$store.getters.settings,
        this.limit,
        'MMM D'
      )
    },

    todayDate() {
      return moment(this.$store.state.date).format('MMM D');
    }
  },

  data() {
    return {
      cursor: null,
    }
  },

  created() {
    this.cursor = new Date();
  },

  methods: {
    today() {
      this.cursor = new Date();
    },

    next() {
      let date = new Date(this.cursor);
      date.setDate(date.getDate() + this.limit);
      this.cursor = date;
    },

    previous() {
      let date = new Date(this.cursor);
      date.setDate(date.getDate() - this.limit);
      this.cursor = date;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/widgets/PrayerTimes.vue